import { Navigate, useParams } from 'react-router-dom';
import LegalDocument from '../components/LegalDocument';
import { getLegalDocument } from '../data/legalDocuments';
import CaymaFormPage from './CaymaFormPage';

export default function LegalDocumentPage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <Navigate to="/" replace />;
  }

  if (slug === 'cayma-formu') {
    return <CaymaFormPage />;
  }

  const document = getLegalDocument(slug);
  if (!document) {
    return <Navigate to="/" replace />;
  }

  return <LegalDocument document={document} />;
}
